import React from "react";
import {
    FieldError as BaseFieldError,
    FieldErrorProps,
} from "react-aria-components";
import { t } from "ttag";

import type { DraftJsContentState } from "@reactivated";

export type FieldProps = {
    errorMessage?: string;
    label: string;
    description?: DraftJsContentState;
};

export function FieldError({ children, ...props }: FieldErrorProps) {
    if (children) return <BaseFieldError {...props}>{children}</BaseFieldError>;
    return (
        <BaseFieldError {...props}>
            {({ validationDetails, validationErrors }) => {
                if (validationDetails.valueMissing)
                    return t`This field is required`;
                return validationErrors;
            }}
        </BaseFieldError>
    );
}
